import { render } from "./DeliveryEstimatorV2.vue?vue&type=template&id=4716cfc0&scoped=true"
import script from "./DeliveryEstimatorV2.vue?vue&type=script&lang=js"
export * from "./DeliveryEstimatorV2.vue?vue&type=script&lang=js"

import "./DeliveryEstimatorV2.vue?vue&type=style&index=0&id=4716cfc0&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4716cfc0"]])

export default __exports__